import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, Page, Proposta } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PropostaService extends BaseResourceService<Proposta> {

  constructor(
    protected injector: Injector
  ) {
    super(`propostas`, injector);
  }

  /**
 * @deprecated Método deverá ser substituído por `obterVencedores`
 */
  public obterVencedoresTransparencia(id: number): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.login.cidade.id}/${this.api}/vencedores?id=${id}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterVencedores(id: number, ordem: string): Observable<Page> {
    if (!ordem) {
      new Error('Ordem não informada');
    }
    const parametros = {
      'memorial.licitacao.id': id,
      'relations': 'memorial,proponente.favorecido',
      'situacao': 'VENCEDOR',
      'orderBy': ordem
    }
    return this.http.get<Page>(
      `${this.login.cidade.id}/${this.api}/filtrar${this.converterParametrosStr(parametros)}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  /**
 * @deprecated Método deverá ser substituído por `obterPorMemorial`
 */
  public obterPorMemorialTransparencia(id: number): Observable<Page> {
    return this.http.get<Page>(
      `${this.login.cidade.id}/${this.api}/filtrar?relations=memorial,proponente.favorecido&licitacao_id=${id}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterPorLicitacao(id: number): Observable<Page> {
    const parametros = {
      'memorial.licitacao.id': id,
      'relations': 'memorial,proponente.favorecido',
      'orderBy': 'memorial.ordem,id'
    }
    return this.http.get<Page>(
      `${this.login.cidade.id}/${this.api}/filtrar${this.converterParametrosStr(parametros)}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterPorMemorial(id: number): Observable<Page> {
    return this.http.get<Page>(
      `${this.login.cidade.id}/${this.api}/filtrar?relations=proponente.favorecido&memorial_id=${id}&orderBy=memorial.ordem,id`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterPorFavorecido(id: number): Observable<Page> {
    return this.http.get<Page>(
      `${this.login.cidade.id}/${this.api}/filtrar?relations=proponente.favorecido&proponente.favorecido_id=${id}&orderBy=memorial.ordem,id`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }
}
